import { useSortBy, useTable } from 'react-table';
import React from 'react';
import { Td, Th } from 'resources/styles/TableStyle';
import { StickyHeader, StyledTr } from './TableComponents';
import { ScrollableTableContainer } from './TableComponents';
import { Table } from 'resources/styles/TableStyle';
import { AdminReservationDto } from 'services/data-contracts';

const TableBody = ({ columns, data, onRowClick }: { columns: any, data: any, onRowClick?: (row: any) => void }) => {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
        {
            columns,
            data,
        },
        useSortBy,
    );
    return <ScrollableTableContainer>
        <Table {...getTableProps()}>
            <StickyHeader>
                {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                            <Th
                                {...column.getHeaderProps((column as any).getSortByToggleProps?.())}
                                style={{ width: (column as any).width }}
                            >
                                {column.render('Header')}
                                <span>
                                    {(column as any).isSorted ? ((column as any).isSortedDesc ? ' 🔽' : ' 🔼') : ''}
                                </span>
                            </Th>
                        ))}
                    </tr>
                ))}
            </StickyHeader>
            <tbody {...getTableBodyProps()}>
                {rows.map((row) => {
                    prepareRow(row);
                    return (
                        <StyledTr
                            {...row.getRowProps()}
                            onClick={() => onRowClick && onRowClick(row.original as AdminReservationDto)}
                        >
                            {row.cells.map((cell) => (
                                <Td {...cell.getCellProps()}>{cell.render('Cell')}</Td>
                            ))}
                        </StyledTr>
                    );
                })}
            </tbody>
        </Table>
    </ScrollableTableContainer>;
};

export default TableBody;
